module.exports = "<div class=\"page-title\">\r\n    <h1>{{ title }}</h1>\r\n</div>\r\n";